module.exports = __webpack_public_path__ + "img/1489861913.c48f9728.jpg";